import { FilterOption } from '@terminal/components/update-filter-options/updateFilterOptions';
import { generateConditionLabel } from '@terminal/utils/condition-utils/condition-utils';
import React from 'react';

import styles from './Filter.module.scss';

export type FilterLabelProps = {
  options: FilterOption[];
  multiselect: boolean;
};

export const FilterLabel = ({ options, multiselect }: FilterLabelProps) => {
  const childNames = options.filter(o => o.childName).map(o => o.name);
  const notChild = (option: FilterOption) => !option.childName;
  const optionCount = options.filter(notChild).length;
  const selectedOption = options.find(notChild);
  const childLabel =
    selectedOption && childNames.length ? `(${childNames.join(' · ')})` : '';

  const displayName = generateConditionLabel(selectedOption) ?? childNames;

  return (
    <span className={styles.selectedValue} data-testid="active-filter-label">
      {childLabel && <span>{childLabel}</span>}
      {optionCount > 1 && multiselect ? (
        <span className={styles.countBadge} data-testid="multiselect-count">
          {optionCount}
        </span>
      ) : (
        <span>{displayName}</span>
      )}
    </span>
  );
};
